import GradientWrapper from "../../GradientWrapper"
import NavLink from "../NavLink"

const Hero = () => (
    <div>
        <section className="mt-10" id="">
            <GradientWrapper wrapperClassName="inset-0" className="custom-screen text-gray-600">
                <div className="space-y-5 max-w-4xl mx-auto text-center">
                    <h1 className="text-4xl text-gray-50 font-extrabold mx-auto sm:text-6xl">
                        Virtual Visa cards <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#9867F0] to-[#ED4E50]">for online payments.</span>
                    </h1>
                    <p className="max-w-xl mx-auto text-gray-50">
                        Avoid revealing your debit and credit card numbers. Instead, opt for Barrenpay Cards which conceal your actual card information and enable you to
                        make payments using distinct virtual Visa cards for any payments and prevent excessive charges and undesired subscriptions..
                    </p>
                    <div className="flex items-center justify-center gap-x-3 font-medium text-sm">
                        <NavLink
                            href="/auth/signup"
                            className="flex items-center gap-x-2 text-white bg-red-600 hover:bg-blue-500 active:bg-red-700 "
                        >
                            Sign Up Now
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                                <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
                            </svg>
                        </NavLink>
                        <NavLink
                            href="#cta"
                            className="flex items-center gap-x-2 text-gray-50 hover:text-gray-50"
                            scroll={false}
                        >
                            FAQ's
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                                <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
                            </svg>
                        </NavLink>
                    </div>
                </div>
            </GradientWrapper>
        </section>

        {/* logos */}

      
    </div>
)

export default Hero